import { lazy } from "react";

export const MainPageComponent = lazy(() => import("./HomePage"));

export const LoginPageComponent = lazy(() => import("./login"));

export const AuthCallbackPageComponent = lazy(() => import("./authCallback"));

export const ManualPageComponent = lazy(() => import("./manual"));

export const LibraryPageComponent = lazy(() => import("./library"));
export const LibraryDatasetsPageComponent = lazy(
  () => import("./library/Datasets")
);
export const LibraryDatasourcesPageComponent = lazy(
  () => import("./library/Datasources")
);
export const LibraryDatasetOnlyPageComponent = lazy(
  () => import("./library/DatasetOnly")
);
export const LibraryAnswersetOnlyPageComponent = lazy(
  () => import("./library/AnswersetOnly")
);

export const LibraryLogsPageComponent = lazy(() => import("./library/Logs"));

export const ProjectPageComponent = lazy(() => import("./project"));
export const ProjectListComponent = lazy(() => import("./project/ProjectList"));
export const ProjectDataComponent = lazy(() => import("./project/ProjectData"));

export const FlowPageComponent = lazy(() => import("./projectFlows"));
export const FlowFlowsComponent = lazy(() => import("./projectFlows/flows"));
export const FlowGroupsComponent = lazy(() => import("./projectFlows/Groups"));
export const FlowLogsComponent = lazy(() => import("./projectFlows/logs"));

export const ReportPageComponent = lazy(() => import("./report"));
export const ReportListComponent = lazy(() => import("./report/ReportList"));
export const ReportDataComponent = lazy(() => import("./report/ReportData"));

export const AdminPageComponent = lazy(() => import("./admin"));
export const AdminUsersPageComponent = lazy(() => import("./admin/Users"));
export const AdminGroupsPageComponent = lazy(() => import("./admin/Groups"));
export const AdminRolesPageComponent = lazy(() => import("./admin/Roles"));
export const AdminConnectorsPageComponent = lazy(
  () => import("./admin/Connectors")
);
export const AdminDomainsPageComponent = lazy(() => import("./admin/Domains"));
export const AdminUserLogsPageComponent = lazy(
  () => import("./admin/UserLogs")
);
export const AdminLogsPageComponent = lazy(() => import("./admin/Monitoring"));

export const ExternalPageComponent = lazy(() => import("./external"));
export const ExternalJupyterPageComponent = lazy(
  () => import("./external/Jupyter")
);

export const ErrorDisplayPageComponent = lazy(
  () => import("./error/ErrorDisplay")
);
export const Error401PageComponent = lazy(() => import("./error/Error401"));
export const Error403PageComponent = lazy(() => import("./error/Error403"));
export const Error404PageComponent = lazy(() => import("./error/Error404"));
export const Error500PageComponent = lazy(() => import("./error/Error500"));
